import { render, staticRenderFns } from "./table-benefits-comparison.vue?vue&type=template&id=26a5aa98&scoped=true&"
import script from "./table-benefits-comparison.vue?vue&type=script&lang=js&"
export * from "./table-benefits-comparison.vue?vue&type=script&lang=js&"
import style0 from "./table-benefits-comparison.vue?vue&type=style&index=0&id=26a5aa98&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26a5aa98",
  null
  
)

export default component.exports